import { useState, useEffect } from 'react'
import { motion, AnimatePresence } from 'framer-motion'

const LINKS = [
  { label: 'Home', href: '#home' },
  { label: 'Services', href: '#services' },
  { label: 'Properties', href: '#properties' },
  { label: 'About', href: '#about' },
  { label: 'Projects', href: '#projects' },
  { label: 'Reviews', href: '#testimonials' },
  { label: 'Contact', href: '#contact' },
]

export default function Header() {
  const [scrolled, setScrolled] = useState(false)
  const [active, setActive] = useState('home')
  const [menuOpen, setMenuOpen] = useState(false)

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 60)
      // active section
      const sections = document.querySelectorAll('section[id]')
      sections.forEach(s => {
        if (window.scrollY >= s.offsetTop - 140) setActive(s.id)
      })
    }
    window.addEventListener('scroll', onScroll)
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  const scrollTo = (href) => {
    const el = document.querySelector(href)
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' })
    setMenuOpen(false)
  }

  return (
    <>
      {/* TOP BAR */}
      <div className="top-bar">
        <div className="container top-bar-inner">
          <div className="top-contacts">
            <a href="tel:+918685838583"><i className="fas fa-phone-alt" style={{color:'var(--gold)',marginRight:6}} />86 8583 8583</a>
            <a href="tel:+918685838533"><i className="fas fa-phone-alt" style={{color:'var(--gold)',marginRight:6}} />86 8583 8533</a>
            <a href="mailto:assubuildtech@gmail.com"><i className="fas fa-envelope" style={{color:'var(--gold)',marginRight:6}} />assubuildtech@gmail.com</a>
          </div>
          <div className="top-socials">
            <a href="https://www.facebook.com/profile.php?id=61586915067932" target="_blank" rel="noreferrer"><i className="fab fa-facebook-f" /></a>
            <a href="https://www.instagram.com/assubuildtech/" target="_blank" rel="noreferrer"><i className="fab fa-instagram" /></a>
            <a href="https://wa.me/918685838583" target="_blank" rel="noreferrer"><i className="fab fa-whatsapp" /></a>
          </div>
        </div>
      </div>

      {/* NAVBAR */}
      <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
        <div className="container nav-inner">
          <a href="#home" className="nav-logo-wrap" onClick={(e)=>{e.preventDefault();scrollTo('#home')}}>
            <div className="nav-logo-main">ASSU <span>BUILDTECH</span></div>
            <div className="nav-logo-sub">Construction & Real Estate</div>
          </a>

          <div className="nav-links">
            {LINKS.map(link => (
              <a
                key={link.href}
                href={link.href}
                className={`nav-link-item ${active === link.href.slice(1) ? 'active' : ''}`}
                onClick={(e) => { e.preventDefault(); scrollTo(link.href) }}
              >
                {link.label}
              </a>
            ))}
            <a className="nav-cta" href="#contact" onClick={(e)=>{e.preventDefault();scrollTo('#contact')}}>
              Free Quote
            </a>
          </div>

          <button className={`hamburger ${menuOpen ? 'open' : ''}`} onClick={() => setMenuOpen(!menuOpen)} aria-label="Toggle navigation menu">
            <span/><span/><span/>
          </button>
        </div>
      </nav>

      {/* MOBILE MENU */}
      <AnimatePresence>
        {menuOpen && (
          <motion.div
            className="mobile-nav"
            initial={{ opacity: 0, x: '100%' }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: '100%' }}
            transition={{ duration: 0.35, ease: 'easeOut' }}
          >
            {LINKS.map((link, i) => (
              <motion.a
                key={link.href}
                href={link.href}
                onClick={(e) => { e.preventDefault(); scrollTo(link.href) }}
                initial={{ opacity: 0, x: 30 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: i * 0.06 }}
              >
                {link.label}
              </motion.a>
            ))}
            <motion.a
              href="#contact"
              className="mobile-cta"
              onClick={(e) => { e.preventDefault(); scrollTo('#contact') }}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.4 }}
            >
              Get Free Quote
            </motion.a>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  )
}
